<template>
  <svg :width="width"
       :height="height"
       :viewBox="viewBox"
       fill="none"
       xmlns="http://www.w3.org/2000/svg"
       class="">
    <path :fill="`url(#paint0_linear_155_${unique_id})`" :d="svgPath" />

    <defs>
      <linearGradient :id="`paint0_linear_155_${unique_id}`"
                      x1="13.3333"
                      y1="0"
                      x2="13.3333"
                      y2="26.6667"
                      gradientUnits="userSpaceOnUse">
        <stop :stop-color="active ? `${$store.state.ui_options.theme?.selected_item_color || '#59BEE5'}` : color" />
        <stop offset="1" :stop-color="active ? `${$store.state.ui_options.theme?.selected_item_color || '#118EBE'}` : color" />
      </linearGradient>
    </defs>
  </svg>
</template>
<script>
import { v4 as uuidv4 } from "uuid"

export default {
  props: {
    active: {
      type: Boolean,
      default: false
    },

    width: {
      type: [Number, String],
      default: 22
    },
    height: {
      type: [Number, String],
      default: 22
    },
    svgPath: {
      type: String,
      default: ""
    },
    color: {
      type: String,
      default: "#899399"
    }
  },
  data() {
    return {
      unique_id: null
    }
  },
  computed: {
    viewBox() {
      return "0 0 " + this.width + " " + this.height
    }
  },
  created() {
    this.unique_id = uuidv4()
  }
}
</script>
